import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Reveal } from "./Reveal";

export function Signup() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await http.post("/subscribe", { email, source: "vip-list" });
      setState("done");
      toast.success(data?.already ? "You're already on the list — see you soon." : "Welcome to the LUMI list.");
    } catch (err) {
      setState("idle");
      toast.error(formatApiError(err));
    }
  };

  return (
    <section className="relative bg-[#4A2E2B] grain overflow-hidden py-24 lg:py-32" data-testid="signup-section">
      <div className="absolute -bottom-40 -left-20 w-[520px] h-[520px] rounded-full bg-[#EBB1B6]/20 blur-3xl" />
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14 grid lg:grid-cols-2 gap-12 items-end">
        <Reveal>
          <p className="overline text-[#EBB1B6]">The LUMI list</p>
          <h2 className="font-display text-[#FAF7F2] text-5xl sm:text-6xl lg:text-7xl mt-5 leading-[0.95]">First to new shades. <span className="italic text-[#EBB1B6]">First to restocks.</span></h2>
        </Reveal>
        <Reveal delay={0.15}>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="signup-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
              disabled={state === "done"} data-testid="signup-email-input"
              className="flex-1 h-14 rounded-full bg-[#FAF7F2]/10 border border-[#EBB1B6]/40 px-6 text-[#FAF7F2] placeholder:text-[#D9C4BC] outline-none focus:border-[#EBB1B6] transition-colors duration-200" />
            <motion.button whileTap={{ scale: 0.96 }} disabled={state !== "idle"} data-testid="signup-submit-btn"
              className="h-14 rounded-full bg-[#EBB1B6] text-[#281715] px-7 flex items-center justify-center gap-2 text-sm font-medium hover:bg-[#FAF7F2] transition-colors duration-200 disabled:opacity-90">
              {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : state === "done" ? <><Check className="w-4 h-4" /> You're in</> : <>Join the list <ArrowRight className="w-4 h-4" /></>}
            </motion.button>
          </form>
          <p className="text-sm text-[#D9C4BC] mt-4">Launch news, new shade drops and restock alerts. Unsubscribe anytime.</p>
        </Reveal>
      </div>
    </section>
  );
}
